import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Modal, FormInput, FormSelect, SearchableList } from '../../components'
import { fetchOrganization, createOrganization, updateOrganization, getOrganizationMembers } from '../../api'
import countries from 'countries-cities'
import { back, replace } from '../../actions/nav-actions';
import { retrieve } from '../../actions/organization-actions';

class Form extends Component {
    constructor(props) {
        super(props);
        const params = props.match.params || {};
        this.state = {
            code: params.code,
            organization: {},
            modal_visible: true,
            options: [],
            members: []
        }
        this.getData = this.getData.bind(this);
        this.onRequest = this.onRequest.bind(this);
    }
    componentDidMount() {
        this.getData();
    }
    getData() {
        setTimeout(() => {
            const options = countries.getCountries().map(option => ({ label: option, value: option }));
            this.setState({ options });
        }, 0)
        if (!this.state.code) return;
        fetchOrganization(
            this.props.user.token,
            this.state.code
        ).then((organization) => {
            return getOrganizationMembers(
                this.props.user.token,
                this.state.code
            ).then((members) => {
                this.setState({ organization, members });
            })
        }).catch((err) => {
            alert(err.message);
        })
    }
    componentWillReceiveProps(newProps) {
        const params = newProps.match.params || {};
        if (params.code !== this.state.code) {
            this.setState({ code: params.code, modal_visible: true }, this.getData);
        }
    }
    onRequest() {
        if (this.state.organization.code) {
            updateOrganization(
                this.props.user.token,
                this.state.organization.code,
                { ...this.state.organization }
            ).then((organization) => {
                this.setState({ organization });
                this.props.retrieve(this.props.user.token);
            }).catch(err => {
                alert(err.message);
            })
            return;
        }
        createOrganization(
            this.props.user.token,
            {
                ...this.state.organization
            }
        ).then((organization) => {
            this.setState({ organization }, () => {
                this.props.replace(`/organizations/${organization.code}`);
                this.props.retrieve(this.props.user.token);
            });
        }).catch(err => {
            alert(err.message);
        })
    }
    render() {
        return (
            <Modal
                visible={this.state.modal_visible}
                onClose={() => this.setState({ modal_visible: false }, this.props.back)}
                title={this.state.organization.code ? 'Update Organization' : 'New Organization'}
                action_text={this.state.organization.code ? 'UPDATE ORGANIZATION' : "ADD ORGANIZATION"}
                onActionClick={this.onRequest}>
                <FormInput
                    onChange={(name) => {
                        let { organization } = this.state;
                        organization.name = name;
                        this.setState({ organization });
                    }}
                    value={this.state.organization.name}
                    placeholder="Name of Organization" />
                <FormInput
                    onChange={(admin_name) => {
                        let { organization } = this.state;
                        organization.admin_name = admin_name;
                        this.setState({ organization });
                    }}
                    value={this.state.organization.admin_name}
                    placeholder="Name of Primary POC/Administrator" />
                <FormInput
                    onChange={(admin_email) => {
                        let { organization } = this.state;
                        organization.admin_email = admin_email;
                        this.setState({ organization });
                    }}
                    value={this.state.organization.admin_email}
                    placeholder="Email of Primary POC/Administrator" />
                <FormInput
                    onChange={(description) => {
                        let { organization } = this.state;
                        organization.description = description;
                        this.setState({ organization });
                    }}
                    value={this.state.organization.description}
                    placeholder="Mission Statement" />
                <FormSelect
                    onChange={(option) => {
                        let { organization } = this.state;
                        organization.country = option.label;
                        this.setState({ organization });
                    }}
                    placeholder="Countries"
                    searchable
                    value={this.state.organization.country}
                    options={this.state.options} />
                <SearchableList
                    formula={(text) => {
                        return (item) => new RegExp((text || '').toLowerCase()).test(item.email.toLocaleLowerCase())
                    }}
                    empty_message="Don't find the searched member mail? Send an invitation on their mailbox"
                    options={this.state.members} />
            </Modal>
        )
    }
}

const mapStateToProps = state => ({ user: state.authReducer.user })

const mapDispatchToProps = dispatch => ({
    back() {
        dispatch(back());
    },
    retrieve(token) {
        dispatch(retrieve(token));
    },
    replace(routeName) {
        dispatch(replace(routeName))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Form)


// WEBPACK FOOTER //
// ./src/routers/Organizations/Form.js